import axios from 'axios';

function consultarBoletim(ra, digito, nascimento, ano) {
    return new Promise((resolve, reject) => {
      /*
      const ra = document.getElementById('ra').value.slice(0, -1);
      const digito = document.getElementById('ra').value.slice(-1);
      const nascimento = document.getElementById('nascimentoBOLETIM').value;
      */
      const url = `https://sed.educacao.sp.gov.br/Boletim/GerarBoletimUnificadoExterno?nrRa=${ra}&nrDigRa=${digito}&dsUfRa=SP&dtNascimento=${nascimento}&nrAnoLetivo=${ano}`;
  
      axios.get(url)
        .then(response => {
          const erro = response.data.slice(10, 14);
  
          if (erro === 'html') {
            reject('Ra e Dígito ou Data de Nascimento inválidos');
          } else if (erro === 'lert') {
            reject('Aluno não encontrado no Sistema');
          } else {
            resolve(response.data);
          }
        })
        .catch(error => {
          reject('Ocorreu um erro na consulta');
        });
    });
  }

  function consultarRa(nome, mae, nascimento) {
    return new Promise((resolve, reject) => {
      const url = 'https://sed.educacao.sp.gov.br/NCA/CadastroAluno/ConsultaRAAluno/PesquisaRAAluno';
      const dados = {
        enModel: {
          CodigoEscola: 22123,
          NomeAluno: nome,
          DataNascimento: nascimento,
          NomeMae: mae
        }
      };
  
      axios.post(url, dados, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(response => {
          const erro = response.data.mensagem;
          if (!erro) {
            const ra = response.data.resultado.NumeroRA;
            const digito = response.data.resultado.DigitoRA;
            if (ra !== null) {
              resolve(`${ra}${digito}`);
            }
          } else {
            reject(erro);
          }
            
        })
        .catch(error => {
          reject(error);
        });
    });
  }

export { consultarBoletim, consultarRa }